import IconSprite from "@images/icons-sprites.svg";

export const RootIcon = (props) => {
  const {
    fill = false,
    onClickIcon,
    width,
    height,
    id,
    disabled = false,
  } = props;

  if (onClickIcon) {
    return (
      <svg
        disabled={disabled}
        onClick={() => onClickIcon()}
        style={{
          pointerEvents: disabled ? "none" : "all",
          opacity: disabled ? "0.5" : "1",
          transition: "all .1s linear",
          width: `${width}rem`,
          height: `${height}rem`,
          fill: fill ? `var(--${fill})` : undefined,
        }}
      >
        <use href={`${IconSprite}#${id}`} />
      </svg>
    );
  } else {
    return (
      <svg
        disabled={disabled}
        style={{
          pointerEvents: disabled ? "none" : "all",
          opacity: disabled ? "0.5" : "1",
          transition: "all .15s linear",
          width: `${width}rem`,
          height: `${height}rem`,
          minWidth: `${width}rem`,
          minHeight: `${height}rem`,
          fill: fill ? `var(--${fill})` : undefined,
        }}
      >
        <use href={`${IconSprite}#${id}`} />
      </svg>
    );
  }
};
